import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div
                                                className="lightgreencontentbg keyquestionpad  greennumberroundbg1 paraspace"
                                                style={{paddingLeft: '39px !important'}}>
                                                <div className="textBoldLightBG task_padding">Step Two</div>
                                                <p>Ask yourself the following of each of the people you
                                                    identified:</p>
                                                <div className="">
                                                    <ul className="greenbullet-list uiheading">
                                                        <li><p>What stressful circumstances did he or she
                                                            encounter?</p></li>
                                                        <textarea className="textareaborder textheght"
                                                                  rows="5"
                                                                  name="1"
                                                                  value={this.props.pageData?.StepTwo?.[1]}
                                                                  onChange={this.props.handleChangePageData('StepTwo')}/>
                                                    </ul>
                                                </div>
                                                <div className="">
                                                    <ul className="greenbullet-list uiheading">
                                                        <li><p>What problem-solving actions did the person take?
                                                            Did they work?</p></li>
                                                        <textarea className="textareaborder textheght"
                                                                  rows="5"
                                                                  name="2"
                                                                  value={this.props.pageData?.StepTwo?.[2]}
                                                                  onChange={this.props.handleChangePageData('StepTwo')}/>
                                                    </ul>
                                                </div>
                                                <div className="">
                                                    <ul className="greenbullet-list uiheading">
                                                        <li><p>Did the person's coping efforts include getting
                                                            support from others?</p></li>
                                                        <textarea className="textareaborder textheght"
                                                                  rows="5"
                                                                  name="3"
                                                                  value={this.props.pageData?.StepTwo?.[3]}
                                                                  onChange={this.props.handleChangePageData('StepTwo')}/>
                                                    </ul>
                                                </div>
                                                <div className="">
                                                    <ul className="greenbullet-list uiheading">
                                                        <li><p>How did his or her coping efforts express
                                                            attitudes of commitment, control and challenge?</p>
                                                        </li>
                                                        <textarea className="textareaborder textheght"
                                                                  rows="5"
                                                                  name="4"
                                                                  value={this.props.pageData?.StepTwo?.[4]}
                                                                  onChange={this.props.handleChangePageData('StepTwo')}/>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="innovativeimg1">
                                                <img
                                                    src={require('@images/arrow1.1.png')}
                                                    alt="" className="task_align_transform"
                                                    style={{transform: 'translate(10px, -40px)', zIndex:105,position: 'relative'}}/>
                                            </div>
                                            <div
                                                className="lightgreencontentbg keyquestionpad  greennumberroundbg1 paraspace"
                                                style={{paddingLeft: '39px !important'}}>
                                                <div className="textBoldLightBG task_padding">Step Three</div>
                                                <p>Reflect on your findings and try to compare them with your
                                                    own reactions to stressful situations. Do you see any
                                                    similarities? Which attitudes do you display well? Which do
                                                    you need to work on?</p><span
                                                style={{paddingLeft:'0px'}}>
                                                <textarea className="textareaborder textheght"
                                                          rows="5"
                                                          name="1"
                                                          value={this.props.pageData?.StepThree?.[1]}
                                                          onChange={this.props.handleChangePageData('StepThree')}/>
                                            </span>
                                                <p>Apply your understanding of those around you to your own
                                                    behaviours - that means borrow the good stuff and actively
                                                    avoid the bad stuff! Practice demonstrating the three
                                                    building blocks of resilience. </p><span
                                                style={{paddingLeft:'0px'}}>
                                                <textarea className="textareaborder textheght"
                                                          rows="5"
                                                          name="2"
                                                          value={this.props.pageData?.StepThree?.[2]}
                                                          onChange={this.props.handleChangePageData('StepThree')}/>
                                            </span>
                                            </div>

                                            <div className="circle_title septor"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>MAINTAINING RESILIENCE – TRANSFORMATIONAL COPING
                                            </div>
                                            <p>Understanding the nature of resilience to build your own
                                                hardiness in the face of adversity is only
                                                the beginning – you need to adopt those characteristics and
                                                maintain them, which is where
                                                transformational coping comes into play.</p>
                                            <p>Transformational coping is a ‘proactive mental and behavioural
                                                coping style’ necessary to staying
                                                resilient. It’s about turning stressful situations into
                                                opportunities and has three stages:</p>
                                            <div className="border_subtitle">Broadening your perspective</div>
                                            <p>The first stage is to make the cause of stress more tolerable by
                                                putting it in perspective. Many
                                                ‘stressors’ at work happen at an organisational level and are
                                                not specifically targeting you. For
                                                example, if your company has significantly increased your
                                                targets for the new financial year,
                                                you might put this in perspective by realising that it’s
                                                reacting to internal and external pressures,
                                                not singling you out as an under-performer. In adjusting your
                                                attitude, you gain a more
                                                balanced perspective and can start developing those resilient
                                                characteristics needed for the
                                                challenges ahead.</p>
                                            <div className="border_subtitle">Deepening your understanding</div>
                                            <p>Next, get a better understanding of what’s stressing you and why.
                                                You, your problems, those
                                                around you and the situation itself all co-exist.
                                                Transformational coping helps you understand
                                                how separate elements interact to create and increase the stress
                                                you feel. Exploring the causes
                                                produces insights and opportunities to make yourself feel and
                                                cope better.</p>
                                            <div className="border_subtitle">Taking decisive action</div>
                                            <p>Now, sitting around, mulling over what’s making you stressed is
                                                pointless unless you decide to do
                                                something about it. Taking decisive action can take a little
                                                courage – there are times when we’d
                                                all rather collapse under the duvet and shut the world out.
                                                Instead, take a few deep breaths and
                                                ‘map out’ a strategy. Using this third element of
                                                transformational coping helps you turn stressful
                                                circumstances around and bring the 3 Cs to the fore.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page5')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}